import { OperationHandler } from '../types';
import { BetweenDateOperationPayload, SingleDateOperationPayload } from './types';

export function useDateOnOperation(payload: SingleDateOperationPayload): OperationHandler {
  return (attribute: Date) => ({ isValid: attribute.getTime() === payload.date.getTime() });
}

export function useDateOnOrAfterOperation(payload: SingleDateOperationPayload): OperationHandler {
  return (attribute: Date) => ({ isValid: attribute.getTime() >= payload.date.getTime() });
}

export function useDateOnOrBeforeOperation(payload: SingleDateOperationPayload): OperationHandler {
  return (attribute: Date) => ({ isValid: attribute.getTime() <= payload.date.getTime() });
}

export function useDateBetweenOperation(payload: BetweenDateOperationPayload): OperationHandler {
  return (attribute: Date) => ({
    isValid: attribute.getTime() >= payload.start.getTime() && attribute.getTime() <= payload.end.getTime(),
  });
}
